<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<div class="body">
<section epub:type="toc">
<p class="FM-Epigraph-non-verse-fmepi"><span aria-label="ix" id="pg_ix" role="doc-pagebreak"><i>“You cannot save the land apart from the people, or the people apart from the land.”</i></span></p>
<p class="FM-Epigraph-Source-fmeps"><span class="small">—WENDELL BERRY</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?0a639d06